// extracted by mini-css-extract-plugin
export var mobileNavModal = "x_bm";